import React, { FC, useState } from 'react'
import { VStack, Center } from '@chakra-ui/react'
import { selectScenario, useSelector } from '../../state'
import theme from '../../styles'
import { useTranslation } from 'react-i18next'
import { Choice } from '../../state/interfaces'

export interface MultiChoiceCheckboxProps {
  onChange?: (values: string[]) => void
  choices: Array<Choice>
}

export const MultiChoiceCheckbox: FC<MultiChoiceCheckboxProps> = ({ onChange, choices }) => {
  const { t } = useTranslation()
  const [selectedServiceTransfer, setSelectedServiceTransfer] = useState<string[]>(() => {
    return choices.filter((choice) => choice.isChecked).map((choice) => choice.value)
  })
  const scenario = useSelector(selectScenario)

  const handleServiceTransferChange = (choice: string) => {
    setSelectedServiceTransfer((prev) => {
      if (prev.includes(choice)) {
        return prev.filter((item) => item !== choice)
      } else {
        return [...prev, choice]
      }
    })
  }

  const handleServiceTransferSubmit = () => {
    onChange && onChange(selectedServiceTransfer.filter((item) => item !== ''))
  }

  return (
    <VStack spacing={4} marginY={8} gridRowGap={4}>
      {scenario?.id === 'lead-internet-mektel' && (
        <>
          <VStack width="fit-content" marginX="auto" alignItems="flex-start" spacing={4}>
            {choices.map((choice) => (
              <label
                key={choice.value}
                style={{
                  display: 'block',
                  textAlign: 'left',
                  fontSize: 18,
                  paddingLeft: '10px',
                }}
              >
                <input
                  type="checkbox"
                  checked={selectedServiceTransfer.includes(choice.value)}
                  onChange={() => handleServiceTransferChange(choice.value)}
                  style={{ marginRight: '10px' }}
                />
                {choice.label}
              </label>
            ))}
          </VStack>
          <Center
            as="button"
            type="button"
            onClick={handleServiceTransferSubmit}
            layerStyle={theme.LayerStyles.LARGE_PILL}
            bg="brand"
            borderColor="brand"
            color="white"
          >
            {t('common_continue')}
          </Center>
        </>
      )}
    </VStack>
  )
}
